<template>
  <div class="chart-scene">
    <echarts
      :options="options"
      @over="handleMouseOver"
      @out="handleMouseOut"
      @click="handleClick"
      class="chart-stage"
    ></echarts>
    <div v-show="showTotal" class="total">
      <p class="name">{{total.name}}</p>
      <p class="value">{{total.value}}</p>
    </div>
  </div>
</template>
<script>
import echarts from "./basic";
import "echarts/lib/chart/pie";
import "echarts/lib/component/tooltip";

export default {
  props: {
    data: {
      type: Array,
      required: true
    },
    colors: {
      type: Array,
      default() {
        return ["#66c676", "#d3d3d3", "#ffd37c", "#ff7c7c", "#4d9bf9"];
      }
    },
    total: {
      type: Object
    },
    dbCilck: {
      type: Boolean,
      default: false
    },
    normalShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      chartWidth: "100%",
      showTotal: true
    };
  },
  computed: {
    options() {
      if (this.normalShow) {
        return {
          backgroundColor: "#fff",
          tooltip: {
            trigger: "item",
            formatter: "{b} : {d}%",
            backgroundColor: "#fff",
            borderColor: "#eee",
            borderWidth: "1",
            textStyle: {
              color: "#999",
              fontSize: 12
            }
          },
          color: this.colors,
          series: [
            //内层圈
            {
              name: "",
              type: "pie",
              selectedMode: "single",
              hoverAnimation: false,
              avoidLabelOverlap: false,
              legendHoverLink: false,
              silent: true,
              center: ["50%", "55%"], //饼图的位置
              radius: ["45%", "55%"],
              label: {
                normal: {
                  show: false,
                  position: "center"
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: "12"
                  },
                  formatter: "{b} \n\n{c}"
                }
              },
              itemStyle: {
                opacity: 0.8
              },
              data: this.data
            },
            {
              name: "",
              type: "pie",
              center: ["50%", "55%"], //圆环图的位置
              radius: ["55%", "75%"], //圆环图的半径大小
              label: {
                normal: {
                  show: true,
                  //  position:'center',
                  //  color:'#000',
                  // formatter: "{a|{a}}{abg|}\n {b|{b}\n}{per|{d}%} | {c}",
                  rich: {
                    a: {
                      color: "#999",
                      align: "center"
                    }
                    // hr: {
                    //   borderColor: "#aaa",
                    //   width: "100%",
                    //   height: 0
                    // }
                  }
                },
                //线上的移入事件
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: "12"
                  },
                  // formatter: "{b} \n{c}"
                }
              },
              labelLine: {
                show: true,
                length: 2
              },

              data: this.data
            }
          ]
        };
      } else {
        return {
          backgroundColor: "#fff",
          tooltip: {
            trigger: "item",
            formatter: "{b} : {d}%",
            backgroundColor: "#fff",
            borderColor: "#eee",
            borderWidth: "1",
            textStyle: {
              color: "#999",
              fontSize: 12
            }
          },
          color: this.colors,
          series: [
            //内层圈
            {
              name: "",
              type: "pie",
              selectedMode: "single",
              silent: true,
              hoverAnimation: false,
              avoidLabelOverlap: false,
              legendHoverLink: false,
              center: ["50%", "55%"], //饼图的位置
              radius: ["45%", "50%"],
              label: {
                normal: {
                  show: false,
                  position: "center"
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: "12"
                  },
                  formatter: "{b} \n\n{c}"
                }
              },
              data: this.data
            },
            {
              name: "",
              type: "pie",
              center: ["50%", "55%"], //圆环图的位置
              radius: ["50%", "70%"], //圆环图的半径大小
              label: {
                normal: {
                  show: false,
                  position: "center"
                  //  formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{per|{d}%}',
                  //   rich: {
                  //       a: {
                  //           color: '#999',
                  //           align: 'center'
                  //       },
                  //       hr: {
                  //           borderColor: '#aaa',
                  //           width: '100%',
                  //           height: 0
                  //       },
                  //   }
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: "12"
                  },
                  formatter: "{b} \n\n{c}"
                }
              },

              data: this.data
            }
          ]
        };
      }
    }
  },

  methods: {
    // 鼠标移入隐藏设备总数
    handleMouseOver() {
      this.showTotal = false;
    },
    // 鼠标移出显示设备总数
    handleMouseOut() {
      this.showTotal = true;
    },
    // 点击状态跳转设备页
    handleClick(param) {
      if (this.dbCilck) {
        return;
      }
      this.$router.push({
        path: "/admin/device",
        query: {
          status: param.name.toLowerCase()
        }
      });
    }
  },
  components: {
    echarts
  }
};
</script>
<style lang="less" scoped>
.chart-scene {
  height: 100%;
  position: relative;
  .chart-stage {
    height: 100%;
  }
  .total {
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-size: 14px;
    color: #333;
    .name {
      margin-bottom: 10px;
    }
    .value {
      font-size: 20px;
      font-weight: bold;
    }
  }
}
</style>


